import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useRef, useState } from 'react';
import { getCodigoTipo } from '../../services/Roles/RolesService';
import { Toast } from 'primereact/toast';

const CreaTipo = ({ onGuardar }) => {
    const [sigla, setSigla] = useState('');
    const [codigoTipo, setCodigoTipo] = useState('');
    const [nombre, setNombre] = useState('');

    const [procesaGuardar, setProcesaGuardar] = useState(false);

    const toastTipo = useRef();

    const handleInput = async (evt) => {
        const nuevoValor = evt.target.value.toUpperCase();
        //console.log ('hola:', nuevoValor)
        if (nuevoValor.length === 3) {
            try {
                const nuevoTipo = await getCodigoTipo(nuevoValor);
                //console.log('0=', nuevoTipo);
                setCodigoTipo(nuevoTipo);
            } catch (err) {
                console.error('Error al conseguir codigo Tipo', err.message);
            }
        } else {
            setCodigoTipo('');
        }
        setSigla(nuevoValor);
    };

    const handleDescripcion = (evt) => {
        const nuevoValor = evt.target.value.toUpperCase();
        setNombre(nuevoValor);
    };

    const handleGuardar = () => {
        if (!codigoTipo) {
            toastTipo.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe haber Codigo Tipo' });
            return;
        }
        if (!nombre) {
            toastTipo.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe tener Descripcion' });
            return;
        }
        const formData = {
            codigo: codigoTipo,
            descripcion: nombre
        };
        setProcesaGuardar(true)
        onGuardar(formData);
    };

    return (
        <div className="card">
            <Toast ref={toastTipo} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-4">
                    <label>Sigla</label>
                </div>
                <div className="field col-12 md:col-4">
                    <InputText value={sigla} maxLength={3} onInput={handleInput} keyfilter={/^[a-zA-Z]*$/} />
                </div>
                <div className="field col-12 md:col-4">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">{codigoTipo}</span>
                </div>
                <div className="field col-12 md:col-4">
                    <label>Nombre:</label>
                </div>
                <div className="field col-12 md:col-8">
                    <InputText value={nombre} maxLength={100} onInput={handleDescripcion} />
                </div>
                <div className="field col-12 md:col-4">
                    <span>{''}</span>
                </div>
                <div className="field col-12 md:col-4">
                    <Button label="Guardar" onClick={handleGuardar} loading={procesaGuardar} />
                </div>
                <div className="field col-12 md:col-4">
                    <span>{''}</span>
                </div>
            </div>
        </div>
    );
};

export default CreaTipo;
